import ContractSpecsPage from './ContractSpecsPage';

export default ContractSpecsPage;
